const getters = {
  sidebar: (state) => state.menuTab.sidebar,
  login: (state) => state.Login.login,
  queryTree: (state) => state.tree.queryTree,
  insertTree: (state) => state.tree.insertTree,
  updateTree: (state) => state.tree.updateTree,
  deleteTree: (state) => state.tree.deleteTree,
  queryTreeOne: (state) => state.tree.queryTreeOne,
  getMenuNode: (state) => state.tree.getMenuNode,
  getAppMenuNode: (state) => state.tree.getAppMenuNode,
  selectUserOrg: (state) => state.tree.selectUserOrg,
  queryCompany: (state) => state.CompanyManagement.queryCompany,
  addCompany: (state) => state.CompanyManagement.addCompany,
  updateCompany: (state) => state.CompanyManagement.updateCompany,
  deleteCompany: (state) => state.CompanyManagement.deleteCompany,
  selectSingleCompany: (state) => state.CompanyManagement.selectSingleCompany,
  updateCompanyRole: (state) => state.CompanyManagement.updateCompanyRole,
  companyBindOrg: (state) => state.CompanyManagement.companyBindOrg,
  setPosition: (state) => state.CompanyManagement.setPosition,
  queryUserList: (state) => state.userManagement.queryUserList,
  addUser: (state) => state.userManagement.addUser,
  updateUser: (state) => state.userManagement.updateUser,
  deleteUser: (state) => state.userManagement.deleteUser,
  resetPassword: (state) => state.userManagement.resetPassword,
  updateUserLoginPwd: (state) => state.userManagement.updateUserLoginPwd,
  selectAllTerminalType: (state) => state.TerminalCommand.selectAllTerminalType,
  insertTerminalType: (state) => state.TerminalCommand.insertTerminalType,
  deleteTerminalType: (state) => state.TerminalCommand.deleteTerminalType,
  selectAliKey: (state) => state.TerminalCommand.selectAliKey,
  insertAliKey: (state) => state.TerminalCommand.insertAliKey,
  deleteAliKey: (state) => state.TerminalCommand.deleteAliKey,
  selectAllBrand: (state) => state.dictionaryManagement.selectAllBrand,
  insertBrand: (state) => state.dictionaryManagement.insertBrand,
  updateBrand: (state) => state.dictionaryManagement.updateBrand,
  deleteBrand: (state) => state.dictionaryManagement.deleteBrand,
  selectAllBrandType: (state) => state.dictionaryManagement.selectAllBrandType,
  insertBrandType: (state) => state.dictionaryManagement.insertBrandType,
  updateBrandType: (state) => state.dictionaryManagement.updateBrandType,
  deleteBrandType: (state) => state.dictionaryManagement.deleteBrandType,
  query: (state) => state.roleManagement.query,
  queryPage: (state) => state.roleManagement.queryPage,
  insertRole: (state) => state.roleManagement.insertRole,
  updateRole: (state) => state.roleManagement.updateRole,
  deleteByid: (state) => state.roleManagement.deleteByid,
  selectTemplateRole: (state) => state.roleManagement.selectTemplateRole,
  selectAllTerminal: (state) => state.TerminalFile.selectAllTerminal,
  insertTerminal: (state) => state.TerminalFile.insertTerminal,
  updateTerminal: (state) => state.TerminalFile.updateTerminal,
  deleteTerminal: (state) => state.TerminalFile.deleteTerminal,
  batchTransferTerminal: (state) => state.TerminalFile.batchTransferTerminal,
  uploadTerminalModel: (state) => state.TerminalFile.uploadTerminalModel,
  syncTerminalOrg: (state) => state.TerminalFile.syncTerminalOrg,
  refreshTerminal: (state) => state.TerminalFile.refreshTerminal,
  abandonedTerminal: (state) => state.TerminalFile.abandonedTerminal,
  selectSim: (state) => state.SIMFile.selectSim,
  insertSim: (state) => state.SIMFile.insertSim,
  updateRemarks: (state) => state.SIMFile.updateRemarks,
  importSim: (state) => state.SIMFile.importSim,
  abandonedSim: (state) => state.SIMFile.abandonedSim,
  deleteSim: (state) => state.SIMFile.deleteSim,
  selectAllDriver: (state) => state.DriverFile.selectAllDriver,
  insertDriver: (state) => state.DriverFile.insertDriver,
  updateDriver: (state) => state.DriverFile.updateDriver,
  deleteDriver: (state) => state.DriverFile.deleteDriver,
  batchTransferDriver: (state) => state.DriverFile.batchTransferDriver,
  uploadDriver: (state) => state.DriverFile.uploadDriver,
  updateDriverNum: (state) => state.DriverFile.updateDriverNum,
  updateDriverUser: (state) => state.DriverFile.updateDriverUser,
  driverPush: (state) => state.DriverFile.driverPush,
  getKey: (state) => state.KeyFile.getKey,
  insertKey: (state) => state.KeyFile.insertKey,
  selectTerminalAll: (state) => state.KeyFile.selectTerminalAll,
  selectAllCar: (state) => state.VehicleFiles.selectAllCar,
  insertCar: (state) => state.VehicleFiles.insertCar,
  updateCar: (state) => state.VehicleFiles.updateCar,
  deleteCar: (state) => state.VehicleFiles.deleteCar,
  batchTransferCar: (state) => state.VehicleFiles.batchTransferCar,
  carBindDriver: (state) => state.VehicleFiles.carBindDriver,
  uploadCar: (state) => state.VehicleFiles.uploadCar,
  queryCarTrajectory: (state) => state.VehicleFiles.queryCarTrajectory,
  carReplaceTerminal: (state) => state.VehicleFiles.carReplaceTerminal,
  updateCarId: (state) => state.VehicleFiles.updateCarId,
  getCarId: (state) => state.VehicleFiles.getCarId,
  carPush: (state) => state.VehicleFiles.carPush,
  selectByCarRealTimeStatus: (state) => state.VehicleStatus.selectByCarRealTimeStatus,
  getCarRealTimeStatus: (state) => state.VehicleStatus.getCarRealTimeStatus,
  getDriverSwipingCardSituation: (state) => state.VehicleStatus.getDriverSwipingCardSituation,
  selectOneCar: (state) => state.VehicleStatus.selectOneCar,
  selectOneDriver: (state) => state.VehicleStatus.selectOneDriver,
  selectOneTerminal: (state) => state.VehicleStatus.selectOneTerminal,
  selectCarLocation: (state) => state.VehicleStatus.selectCarLocation,
  getCarOperationList: (state) => state.VehicleStatus.getCarOperationList,
  carSpotCheck: (state) => state.VehicleStatus.carSpotCheck,
  findFaultData: (state) => state.FaultManagement.findFaultData,
  findViolationData: (state) => state.ViolationControl.findViolationData,
  queryInstructList: (state) => state.EquipmentControl.queryInstructList,
  addBriefnessInstruct: (state) => state.EquipmentControl.addBriefnessInstruct,
  addComplexInstruct: (state) => state.EquipmentControl.addComplexInstruct,
  reTry: (state) => state.EquipmentControl.reTry,
  cancel: (state) => state.EquipmentControl.cancel,
  queryByType: (state) => state.EquipmentControl.queryByType,
  exportTerminalId: (state) => state.EquipmentControl.exportTerminalId,

  getFenceTerminal: (state) => state.ElectricFence.getFenceTerminal,
  getElectronicFence: (state) => state.ElectricFence.getElectronicFence,
  insertElectronicFence: (state) => state.ElectricFence.insertElectronicFence,
  updateElectronicFence: (state) => state.ElectricFence.updateElectronicFence,
  deleteElectronicFence: (state) => state.ElectricFence.deleteElectronicFence,
  getFenceCarMessage: (state) => state.ElectricFence.getFenceCarMessage,
  getChoiceTerminal: (state) => state.ElectricFence.getChoiceTerminal,

  getCloudFence: (state) => state.CloudFence.getCloudFence,
  getFenceCar: (state) => state.CloudFence.getFenceCar,
  addCloudFence: (state) => state.CloudFence.addCloudFence,
  updateCloudFence: (state) => state.CloudFence.updateCloudFence,
  deleteCloudFence: (state) => state.CloudFence.deleteCloudFence,
  getChoiceCar: (state) => state.CloudFence.getChoiceCar,

  queryOTA: (state) => state.OTAManagement.queryOTA,
  insertOTA: (state) => state.OTAManagement.insertOTA,
  updateOTA: (state) => state.OTAManagement.updateOTA,
  deleteOTA: (state) => state.OTAManagement.deleteOTA,
  publishOTA: (state) => state.OTAManagement.publishOTA,
  cancelOTA: (state) => state.OTAManagement.cancelOTA,
  selectStation: (state) => state.SiteFile.selectStation,
  insertStation: (state) => state.SiteFile.insertStation,
  updateStation: (state) => state.SiteFile.updateStation,
  deleteStation: (state) => state.SiteFile.deleteStation,
  queryContractList: (state) => state.ContractManagement.queryContractList,
  insertContract: (state) => state.ContractManagement.insertContract,
  deleteContract: (state) => state.ContractManagement.deleteContract,
  getImage: (state) => state.FileController.getImage,
  upload: (state) => state.FileController.upload,
  uploadContractFile: (state) => state.FileController.uploadContractFile,
  getFile: (state) => state.FileController.getFile,
  queryRepairList: (state) => state.MaintainManagement.queryRepairList,
  insertRepair: (state) => state.MaintainManagement.insertRepair,
  urgeRepair: (state) => state.MaintainManagement.urgeRepair,
  finishRepair: (state) => state.MaintainManagement.finishRepair,
  queryMaintainList: (state) => state.MaintainManagement.queryMaintainList,
  insertMaintain: (state) => state.MaintainManagement.insertMaintain,
  deleteMaintain: (state) => state.MaintainManagement.deleteMaintain,
  selectCarRoute: (state) => state.RouteFile.selectCarRoute,
  insertCarRoute: (state) => state.RouteFile.insertCarRoute,
  updateCarRoute: (state) => state.RouteFile.updateCarRoute,
  deleteCarRoute: (state) => state.RouteFile.deleteCarRoute,
  queryReminderList: (state) => state.MaintenanceManagement.queryReminderList,
  insertReminder: (state) => state.MaintenanceManagement.insertReminder,
  queryOrderList: (state) => state.MaintenanceManagement.queryOrderList,
  deleteMaterial: (state) => state.MaintenanceManagement.deleteMaterial,
  updateMaterial: (state) => state.MaintenanceManagement.updateMaterial,
  queryCarData: (state) => state.HomePage.queryCarData,
  queryCarDataCount: (state) => state.HomePage.queryCarDataCount,
  queryViolationCount: (state) => state.HomePage.queryViolationCount,
  queryProblemCount: (state) => state.HomePage.queryProblemCount,
  queryCarDataList: (state) => state.HomePage.queryCarDataList,
  queryDriverDataList: (state) => state.HomePage.queryDriverDataList,
  selectUserLocation: (state) => state.HomePage.selectUserLocation,

  getStatisticalData: (state) => state.HomePage.getStatisticalData,
  getCarAgeProportion: (state) => state.HomePage.getCarAgeProportion,
  getCarCapacityProportion: (state) => state.HomePage.getCarCapacityProportion,
  getCarWorkRate: (state) => state.HomePage.getCarWorkRate,
  getCarSpotCheckRate: (state) => state.HomePage.getCarSpotCheckRate,
  getCarDistributionState: (state) => state.HomePage.getCarDistributionState,

  selectCarOrder: (state) => state.VehicleAnalysis.selectCarOrder,
  selectCarOrderList: (state) => state.VehicleAnalysis.selectCarOrderList,
  SelectTodayWorkTimePage: (state) => state.VehicleAnalysis.SelectTodayWorkTimePage,
  SelectUseRatePage: (state) => state.VehicleAnalysis.SelectUseRatePage,
  selectDailyUseRate: (state) => state.VehicleAnalysis.selectDailyUseRate,
  SelectTodayProblemCountPage: (state) => state.VehicleAnalysis.SelectTodayProblemCountPage,
  queryFaultCountPeriod: (state) => state.VehicleAnalysis.queryFaultCountPeriod,
  queryFaultCountPeriodRate: (state) => state.VehicleAnalysis.queryFaultCountPeriodRate,
  queryFaultPageByCar: (state) => state.VehicleAnalysis.queryFaultPageByCar,
  selectAllCarAndWorkTime: (state) => state.VehicleAnalysis.selectAllCarAndWorkTime,
  queryCarDayWorkTime: (state) => state.VehicleAnalysis.queryCarDayWorkTime,
  selectDriverTimeOrder: (state) => state.DriverAnalysis.selectDriverTimeOrder,
  selectDriverAlarmOrder: (state) => state.DriverAnalysis.selectDriverAlarmOrder,
  selectDriverCardOrder: (state) => state.DriverAnalysis.selectDriverCardOrder,
  selectDriverOrderList: (state) => state.DriverAnalysis.selectDriverOrderList,
  selectDriverDailyUseRate: (state) => state.DriverAnalysis.selectDriverDailyUseRate,
  selectDriverUseRatePage: (state) => state.DriverAnalysis.selectDriverUseRatePage,
  SelectDriverTodayWorkTimePage: (state) => state.DriverAnalysis.SelectDriverTodayWorkTimePage,
  SelectDriverTodayMistakeCountPage: (state) => state.DriverAnalysis.SelectDriverTodayMistakeCountPage,
  queryDriverCountMistakePeriod: (state) => state.DriverAnalysis.queryDriverCountMistakePeriod,
  queryDriverCountPeriodRate: (state) => state.DriverAnalysis.queryDriverCountPeriodRate,
  queryMistakePageByDriver: (state) => state.DriverAnalysis.queryMistakePageByDriver,
  selectDriverAllWorkRecord: (state) => state.DriverAnalysis.selectDriverAllWorkRecord,
  queryDriverDayWorkTime: (state) => state.DriverAnalysis.queryDriverDayWorkTime,
  SelectBatteryPage: (state) => state.BatteryAnalysis.SelectBatteryPage,
  queryBatteryCountDrawing: (state) => state.BatteryAnalysis.queryBatteryCountDrawing,
  queryBatteryOrganizationPage: (state) => state.BatteryAnalysis.queryBatteryOrganizationPage,
  queryBatterySinglePage: (state) => state.BatteryAnalysis.queryBatterySinglePage,

  selectCostCompare: (state) => state.MaintenanceAnalysis.selectCostCompare,
  selectCostRate: (state) => state.MaintenanceAnalysis.selectCostRate,
  selectCostList: (state) => state.MaintenanceAnalysis.selectCostList,
  selectMaintainNumber: (state) => state.MaintenanceAnalysis.selectMaintainNumber,
  selectCarMaintain: (state) => state.MaintenanceAnalysis.selectCarMaintain,
  selectMaintain: (state) => state.MaintenanceAnalysis.selectMaintain,

  selectAuthorizeMangerPage: (state) => state.AuthorizationManagement.selectAuthorizeMangerPage,
  InsertAuthorizeTerminal: (state) => state.AuthorizationManagement.InsertAuthorizeTerminal,
  selectAuthorizeByDriver: (state) => state.AuthorizationManagement.selectAuthorizeByDriver,
  syncTerminalAuthorize: (state) => state.AuthorizationManagement.syncTerminalAuthorize,
  driverAuthorizeSync: (state) => state.AuthorizationManagement.driverAuthorizeSync,

  DriverFingerprint: (state) => state.DriverFingerprintFile.DriverFingerprint,
  insertDriverFinger: (state) => state.DriverFingerprintFile.insertDriverFinger,
  deleteDriverFinger: (state) => state.DriverFingerprintFile.deleteDriverFinger,
  FingerprintLibraryList: (state) => state.DriverFingerprintFile.FingerprintLibraryList,
  insertFingerprintLibrary: (state) => state.DriverFingerprintFile.insertFingerprintLibrary,
  updateFingerprintLibrary: (state) => state.DriverFingerprintFile.updateFingerprintLibrary,
  deleteFingerprintLibrary: (state) => state.DriverFingerprintFile.deleteFingerprintLibrary,
  transferFingerprintLibrary: (state) => state.DriverFingerprintFile.transferFingerprintLibrary,
  selectPrintLibraryList: (state) => state.DriverFingerprintFile.selectPrintLibraryList,
  selectFingerList: (state) => state.DriverFingerprintFile.selectFingerList,
  IssueFingerToCarList: (state) => state.DriverFingerprintFile.IssueFingerToCarList,
  selectAllFingerByCar: (state) => state.DriverFingerprintFile.selectAllFingerByCar,
  deleteByDriverNum: (state) => state.DriverFingerprintFile.deleteByDriverNum,
  selectDriverFinger: (state) => state.DriverFingerprintFile.selectDriverFinger,
  addDriverFinger: (state) => state.DriverFingerprintFile.addDriverFinger,
  selectCheckedDriver: (state) => state.DriverFingerprintFile.selectCheckedDriver,
  queryBatteryPage: (state) => state.BatteryFile.queryBatteryPage,
  addBattery: (state) => state.BatteryFile.addBattery,
  updateBattery: (state) => state.BatteryFile.updateBattery,
  deleteBatteryById: (state) => state.BatteryFile.deleteBatteryById,
  batteryAppropriate: (state) => state.BatteryFile.batteryAppropriate,
  batteryBinding: (state) => state.BatteryFile.batteryBinding,
  uploadBattery: (state) => state.BatteryFile.uploadBattery,
  queryBatteryStatusPage: (state) => state.BatteryFile.queryBatteryStatusPage,
  queryBatteryInfo: (state) => state.BatteryFile.queryBatteryInfo,
  queryBatteryChargeInfo: (state) => state.BatteryFile.queryBatteryChargeInfo,
  queryBatteryPower: (state) => state.BatteryFile.queryBatteryPower,
  selectCarCheck: (state) => state.checkManagement.selectCarCheck,
  insertCarCheck: (state) => state.checkManagement.insertCarCheck,
  updateCarCheck: (state) => state.checkManagement.updateCarCheck,
  deleteCarCheck: (state) => state.checkManagement.deleteCarCheck,
  moveCarCheck: (state) => state.checkManagement.moveCarCheck,
  selectCheckList: (state) => state.checkManagement.selectCheckList,
  selectCheckRate: (state) => state.checkManagement.selectCheckRate,
  selectStateRate: (state) => state.checkManagement.selectStateRate,
  selectSpotCheck: (state) => state.checkManagement.selectSpotCheck,
  selectSpotCheckStatement: (state) => state.checkManagement.selectSpotCheckStatement,
  insertSpotCheck: (state) => state.checkManagement.insertSpotCheck,
  querySpotCheckReport: (state) => state.checkManagement.querySpotCheckReport,

  selectDriverFace: (state) => state.DriverFaceFile.selectDriverFace,
  updateDriverFace: (state) => state.DriverFaceFile.updateDriverFace,

  queryTaskReport: (state) => state.ReportPush.queryTaskReport,
  queryTaskUser: (state) => state.ReportPush.queryTaskUser,
  subsReports: (state) => state.ReportPush.subsReports,
  cancelReport: (state) => state.ReportPush.cancelReport,

  selectCarFingerAuthorizeList: (state) => state.FingerprintAuthorization.selectCarFingerAuthorizeList,
  insertAuthorize: (state) => state.FingerprintAuthorization.insertAuthorize,
  fingerWarehouseAuthorize: (state) => state.FingerprintAuthorization.fingerWarehouseAuthorize,
  clearAuthorize: (state) => state.FingerprintAuthorization.clearAuthorize,
  selectDriverAuthorizeList: (state) => state.FingerprintAuthorization.selectDriverAuthorizeList,
  deleteAuthorize: (state) => state.FingerprintAuthorization.deleteAuthorize,
  refresh: (state) => state.FingerprintAuthorization.refresh,
  selectCarFingerWarehouse: (state) => state.FingerprintAuthorization.selectCarFingerWarehouse,

  getDictType: (state) => state.DictionaryManaged.getDictType,
  addDictType: (state) => state.DictionaryManaged.addDictType,
  updateDictType: (state) => state.DictionaryManaged.updateDictType,
  deleteDictType: (state) => state.DictionaryManaged.deleteDictType,
  refreshData: (state) => state.DictionaryManaged.refreshData,
  getDictValue: (state) => state.DictionaryManaged.getDictValue,
  addDictValue: (state) => state.DictionaryManaged.addDictValue,
  updateDictValue: (state) => state.DictionaryManaged.updateDictValue,
  deleteDictValue: (state) => state.DictionaryManaged.deleteDictValue,
  selectRepairType: (state) => state.DictionaryManaged.selectRepairType,
  selectMalfunctionType: (state) => state.DictionaryManaged.selectMalfunctionType,
  selectExternalType: (state) => state.DictionaryManaged.selectExternalType,
  selectHomePageUrl: (state) => state.DictionaryManaged.selectHomePageUrl,
  selectCarOperationType: (state) => state.DictionaryManaged.selectCarOperationType,
  selectTonnageType: (state) => state.DictionaryManaged.selectTonnageType,

  selectCarInsurance: (state) => state.InsureFile.selectCarInsurance,
  updateCarInsurance: (state) => state.InsureFile.updateCarInsurance,
  uploadCarInsurance: (state) => state.InsureFile.uploadCarInsurance,
  keepAliveInclude: (state) => state.cache.keepAliveInclude,

  getTrainList: (state) => state.DriverTrain.getTrainList,
  insertTrain: (state) => state.DriverTrain.insertTrain,
  updateTrain: (state) => state.DriverTrain.updateTrain,
  deleteTrain: (state) => state.DriverTrain.deleteTrain,
  updateFixed: (state) => state.DriverTrain.updateFixed,
  getExamDriver: (state) => state.DriverTrain.getExamDriver,
  getExamQuestion: (state) => state.DriverTrain.getExamQuestion,

  getCarFault: (state) => state.navMenu.getCarFault,
  getDriverViolation: (state) => state.navMenu.getDriverViolation,
  insertRequestRepair: (state) => state.navMenu.insertRequestRepair,
  pushViolation: (state) => state.navMenu.pushViolation,
  updateHandleState: (state) => state.navMenu.updateHandleState,
  selectFaultType: (state) => state.navMenu.selectFaultType,
  selectViolationType: (state) => state.navMenu.selectViolationType,
  getUserProfile: (state) => state.navMenu.getUserProfile,
  updateUserProfile: (state) => state.navMenu.updateUserProfile,

  selectKeyAuthorizeList: (state) => state.ICEmpower.selectKeyAuthorizeList,
  insertKeyAuthorize: (state) => state.ICEmpower.insertKeyAuthorize,
  ICAuthorize: (state) => state.ICEmpower.ICAuthorize,
  clearICAuthorize: (state) => state.ICEmpower.clearICAuthorize,
  deleteICAuthorize: (state) => state.ICEmpower.deleteICAuthorize,
  selectTerminalAuthorize: (state) => state.ICEmpower.selectTerminalAuthorize,
  refreshIC: (state) => state.ICEmpower.refreshIC,

  selectFaceAuthorizeResponse: (state) => state.FaceAuthorize.selectFaceAuthorizeResponse,
  insertFaceAuthorizeResponse: (state) => state.FaceAuthorize.insertFaceAuthorizeResponse,
  insertAuthorizeResponse: (state) => state.FaceAuthorize.insertAuthorizeResponse,
  clearAuthorizeResponse: (state) => state.FaceAuthorize.clearAuthorizeResponse,
  deleteICAuthorizeResponse: (state) => state.FaceAuthorize.deleteICAuthorizeResponse,
  selectFaceAuthorizeRecordResponse: (state) => state.FaceAuthorize.selectFaceAuthorizeRecordResponse,
  selectFaceAuthorizeOperation: (state) => state.FaceAuthorize.selectFaceAuthorizeOperation,

  selectCarState: (state) => state.VehicleDistribution.selectCarState,
  selectCarLocationList: (state) => state.VehicleDistribution.selectCarLocationList,

  getJurisdiction: (state) => state.JurisdictionalManagement.getJurisdiction,
  insertJurisdiction: (state) => state.JurisdictionalManagement.insertJurisdiction,
  updateJurisdiction: (state) => state.JurisdictionalManagement.updateJurisdiction,
  deleteJurisdiction: (state) => state.JurisdictionalManagement.deleteJurisdiction,

  getJurisdictionCompany: (state) => state.JurisdictionalCompanies.getJurisdictionCompany,
  addJurisdictionCompany: (state) => state.JurisdictionalCompanies.addJurisdictionCompany,
  deleteJurisdictionCompany: (state) => state.JurisdictionalCompanies.deleteJurisdictionCompany,
  uploadJurisdictionCompany: (state) => state.JurisdictionalCompanies.uploadJurisdictionCompany,

  getJurisdictionCar: (state) => state.JurisdictionalCompanies.getJurisdictionCar,
  getJurisdictionDriver: (state) => state.JurisdictionalCompanies.getJurisdictionDriver,

  getJurisdictionSurvey: (state) => state.JurisdictionalAnalysis.getJurisdictionSurvey,
  getDriverCarRate: (state) => state.JurisdictionalAnalysis.getDriverCarRate,
  getDeviceDismantle: (state) => state.JurisdictionalAnalysis.getDeviceDismantle,
  getCarEmissionRate: (state) => state.JurisdictionalAnalysis.getCarEmissionRate,
  getSafetyDeviceRate: (state) => state.JurisdictionalAnalysis.getSafetyDeviceRate,
  getCarAgeRate: (state) => state.JurisdictionalAnalysis.getCarAgeRate,
  getCarMaintainRate: (state) => state.JurisdictionalAnalysis.getCarMaintainRate,
  getCheckRate: (state) => state.JurisdictionalAnalysis.getCheckRate,
  getSpotCheckAbnormalRate: (state) => state.JurisdictionalAnalysis.getSpotCheckAbnormalRate,

  getSafetySurvey: (state) => state.SecureAnalysis.getSafetySurvey,
  getViolationTrend: (state) => state.SecureAnalysis.getViolationTrend,
  getViolationAnalysis: (state) => state.SecureAnalysis.getViolationAnalysis,
  getCarViolationDetail: (state) => state.SecureAnalysis.getCarViolationDetail,

  getExecuteLawNote: (state) => state.EnforcementNotes.getExecuteLawNote,
  getNoteDetails: (state) => state.EnforcementNotes.getNoteDetails,
  getCompanyReply: (state) => state.EnforcementNotes.getCompanyReply,
  getCompanyReplyDetails: (state) => state.EnforcementNotes.getCompanyReplyDetails,

  getCarAnnualApproveList: (state) => state.VehicleAnnualReview.getCarAnnualApproveList,
  getCarApproveProgressList: (state) => state.VehicleAnnualReview.getCarApproveProgressList,
  submitCarAudit: (state) => state.VehicleAnnualReview.submitCarAudit,

  getRegulations: (state) => state.PolicyRule.getRegulations,
  insertRegulations: (state) => state.PolicyRule.insertRegulations,
  deleteRegulations: (state) => state.PolicyRule.deleteRegulations,

  getDriverAnnualApproveList: (state) => state.DriverAnnualReview.getDriverAnnualApproveList,
  getDriverApproveProgressList: (state) => state.DriverAnnualReview.getDriverApproveProgressList,
  submitDriverAudit: (state) => state.DriverAnnualReview.submitDriverAudit,

  getAnnualApproveList: (state) => state.AnnualReview.getAnnualApproveList,
  batchUpdateAudit: (state) => state.AnnualReview.batchUpdateAudit,
  updateAudit: (state) => state.AnnualReview.updateAudit,

  selectExternal: (state) => state.ExternalEqu.selectExternal,
  insertExternal: (state) => state.ExternalEqu.insertExternal,
  updateExternal: (state) => state.ExternalEqu.updateExternal,
  deleteExternal: (state) => state.ExternalEqu.deleteExternal,
  externalBindingCar: (state) => state.ExternalEqu.externalBindingCar,

  selectMenuNode: (state) => state.MenuManagement.selectMenuNode,
  addModule: (state) => state.MenuManagement.addModule,
  addMenuNode: (state) => state.MenuManagement.addMenuNode,
  updateMenuNode: (state) => state.MenuManagement.updateMenuNode,
  deleteMenuNode: (state) => state.MenuManagement.deleteMenuNode,

  selectRenew: (state) => state.EquipmentRenewal.selectRenew,
  updateRenew: (state) => state.EquipmentRenewal.updateRenew,
  deviceRenew: (state) => state.EquipmentRenewal.deviceRenew,
  deviceScrap: (state) => state.EquipmentRenewal.deviceScrap,

  selectMaintainProject: (state) => state.MaintenanceProgram.selectMaintainProject,
  insertMaintainProject: (state) => state.MaintenanceProgram.insertMaintainProject,
  updateMaintainProject: (state) => state.MaintenanceProgram.updateMaintainProject,
  deleteMaintainProject: (state) => state.MaintenanceProgram.deleteMaintainProject,
  selectProject: (state) => state.MaintenanceProgram.selectProject,
  selectTreeFormProject: (state) => state.MaintenanceProgram.selectTreeFormProject,

  getRequestRepairList: (state) => state.RepairManagement.getRequestRepairList,
  insertRequestRepair: (state) => state.RepairManagement.insertRequestRepair,
  updateRequestRepair: (state) => state.RepairManagement.updateRequestRepair,
  deleteRequestRepair: (state) => state.RepairManagement.deleteRequestRepair,
  getRequestRepair: (state) => state.RepairManagement.getRequestRepair,
  getRepair: (state) => state.RepairManagement.getRepair,
  updateUrgeCount: (state) => state.RepairManagement.updateUrgeCount,
  updateRepairState: (state) => state.RepairManagement.updateRepairState,
  updateCloseTime: (state) => state.RepairManagement.updateCloseTime,
  getRepairList: (state) => state.RepairManagement.getRepairList,
  updateRepairUser: (state) => state.RepairManagement.updateRepairUser,
  insertRepair: (state) => state.RepairManagement.insertRepair,
  abandonRequestRepair: (state) => state.RepairManagement.abandonRequestRepair,
  getCarMessage: (state) => state.RepairManagement.getCarMessage,

  queryLogList: (state) => state.OperationLog.queryLogList,

  selectShiftList: (state) => state.ShiftSchedule.selectShiftList,
  insertShift: (state) => state.ShiftSchedule.insertShift,
  updateShift: (state) => state.ShiftSchedule.updateShift,
  deleteShift: (state) => state.ShiftSchedule.deleteShift,
  selectShift: (state) => state.ShiftSchedule.selectShift,
  selectShiftApplication: (state) => state.ShiftSchedule.selectShiftApplication,
  insertShiftApplication: (state) => state.ShiftSchedule.insertShiftApplication,
  updateShiftApplication: (state) => state.ShiftSchedule.updateShiftApplication,
  deleteShiftApplication: (state) => state.ShiftSchedule.deleteShiftApplication,
  selectApplication: (state) => state.ShiftSchedule.selectApplication,
  choiceShiftList: (state) => state.ShiftSchedule.choiceShiftList,
  choiceShiftCar: (state) => state.ShiftSchedule.choiceShiftCar,
  choiceShiftDriver: (state) => state.ShiftSchedule.choiceShiftDriver,

  getCarRepairList: (state) => state.CarRepair.getCarRepairList,
  insertCarRepair: (state) => state.CarRepair.insertCarRepair,
  getRepair: (state) => state.CarRepair.getRepair,

  selectCarDayOverview: (state) => state.HomeMasterKong.selectCarDayOverview,
  selectDriverOverview: (state) => state.HomeMasterKong.selectDriverOverview,
  selectDriverWorkRank: (state) => state.HomeMasterKong.selectDriverWorkRank,
  selectCompanyCar: (state) => state.HomeMasterKong.selectCompanyCar,
  selectCompanyDriver: (state) => state.HomeMasterKong.selectCompanyDriver,
  selectCompanyWorkRank: (state) => state.HomeMasterKong.selectCompanyWorkRank,
  selectCityCar: (state) => state.HomeMasterKong.selectCityCar,

  selectCarDayWorkDistribution: (state) => state.ReportAnalysis.selectCarDayWorkDistribution,
  selectCarHomeworkDetails: (state) => state.ReportAnalysis.selectCarHomeworkDetails,
  selectCarOverview: (state) => state.ReportAnalysis.selectCarOverview,
  selectCarHomeworkTable: (state) => state.ReportAnalysis.selectCarHomeworkTable,
  selectDriverHomeworkDetails: (state) => state.ReportAnalysis.selectDriverHomeworkDetails,
  selectDriverHomeworkTable: (state) => state.ReportAnalysis.selectDriverHomeworkTable,
  selectCarHomeworkWork: (state) => state.ReportAnalysis.selectCarHomeworkWork,
  selectDriverHomeworkWork: (state) => state.ReportAnalysis.selectDriverHomeworkWork,

  selectCarVideoPreviewList: (state) => state.VideoPreview.selectCarVideoPreviewList,
  startLiveVideo: (state) => state.VideoPreview.startLiveVideo,
  stopLiveVideo: (state) => state.VideoPreview.stopLiveVideo,
  convertVideoFormat: (state) => state.VideoPreview.convertVideoFormat,
  getPlayList: (state) => state.VideoPreview.getPlayList,
  startHistoryVideo: (state) => state.VideoPreview.startHistoryVideo,
  stopHistoryVideo: (state) => state.VideoPreview.stopHistoryVideo,
};

export default getters;
